<template>
  <div class="um-distribution-map">
    <div ref="mapContainer"></div>
    
    <div class="um-distribution-map-controls">
      <div class="um-distribution-map-ctrl um-distribution-map-ctrl--start" style="position: relative;top: -1.75rem;">
        <slot name="title" v-bind:title="{lastUpdated}">
          <h5 class="um-distribution-map__title" style="margin:0">
            {{label}} {{lastUpdated}}
          </h5>
        </slot>
        <slot name="subtitle">
          <div class="um-distribution-map__subtitle">
            Scroll down to see example app data charts <span style="font-size:150%;vertical-align: middle">&darr;</span>
          </div>
        </slot>
      </div>
      <div class="um-distribution-map-ctrl um-distribution-map-ctrl--end">
        <div class="um-distribution-map-slider">
          <div class="um-distribution-map-slider__control">

            <div class="um-distribution-map-slider-label um-distribution-map-slider-label--input" :style="`left: ${sliderVal * 100}%`">{{currentTime | shortTime}}</div>

            <input
              class="um-distribution-map-slider-input"
              type="range"
              :min="0" 
              :max="1"
              :step="1 / ((maxTime - minTime) / stepTime)"
              v-model="sliderVal"
              @input="filterByTime($event.target.value, true)"
            />

          </div>
          <div class="um-distribution-map-slider__labels">
            <div class="um-distribution-map-slider-label">{{minTime | shortestTime}}</div>
            <div class="um-distribution-map-slider-label">{{maxTime | shortestTime}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mapboxgl from 'mapbox-gl'

  export default {
    name: 'UMDistributionMap',

    props: {
      label: String,
      api: String,
      accessToken: {
        type: String,
        default: 'pk.eyJ1IjoidXJiYW5taW5kIiwiYSI6ImNqaW02Y3F1ajAwdHMzcHJ0c3U3ODVzZHMifQ.iI1BHkm0eUec4zAfdZ64vQ'
      },
      styleUrl: {
        type: String,
        default: 'mapbox://styles/urbanmind/cjn5vty780qul2smkkh3wjkiz'
      }
    },

    data () {
      return {
        minTime: 1524006000000, //https://urbanmind-e9da8.firebaseio.com/locations.json?orderBy="properties/first_time"&limitToFirst=1
        maxTime: 1528930800000, //https://urbanmind-e9da8.firebaseio.com/locations.json?orderBy="properties/last_time"&limitToLast=1
        currentTime: 1524006000000, //https://urbanmind-e9da8.firebaseio.com/locations.json?orderBy="properties/first_time"&limitToFirst=1
        stepTime: 86200000,
        sliderVal: 0,
        lastUpdated: null //https://urbanmind-e9da8.firebaseio.com/imports.json?orderBy="timestamp"&limitToLast=1
      }
    },

    created () {
      mapboxgl.accessToken = this.accessToken
      fetch(this.api + '/stats/maxtime')
      .then(resp => resp.json())
      .then(({timestamp}) => {
        this.maxTime = Date.parse(timestamp)
      })

      fetch(this.api + '/stats/lastupdated')
      .then(resp => resp.json())
      .then(({created_at}) => {
        this.lastUpdated = `(up to ${new Date(created_at).toDateString()})`
      })
    },

    mounted () {
      this.map = new mapboxgl.Map({
        container: this.$refs.mapContainer,
        style: this.styleUrl,
        minZoom: 0,
        maxZoom: 10,
        zoom: 0,
        attributionControl: false,
        logoPosition: 'bottom-left',
        scrollZoom: false,
        refreshExpiredTiles: true,
        maxTileCacheSizenumber: 1,
        transformRequest: (url, resourceType)=> {
          if(resourceType === 'Tile') {
            return {url: `${url}&time=${Date.now()}`}
          }
        }
      })
      this.map.addControl(new mapboxgl.NavigationControl())
      this.map.on('load', this.startAnimate)
      const initialClear = () => {
          this.filterByTime(0)
          this.map.off('data', initialClear)
          this.map.resize()
      }
      this.map.on('data', initialClear)
    },

    beforeDestroy () {
      if (this.animateInt) clearInterval(this.animateInt)
    },

    methods: {
      filterByTime(sliderVal, manual = false) {
        const currentTime = this.minTime + (sliderVal * (this.maxTime - this.minTime))
        const firstTime = ['<=', ['number', ['get', 'first_time']], currentTime]
        this.map.setFilter('assessments', ['all', firstTime])
        this.currentTime = currentTime
        if (sliderVal >= 1 || (manual && this.animateInt)) clearInterval(this.animateInt)
      },
      clearTimeFilter(){
        this.map.setFilter('assessments', null)
        this.sliderVal = 1
      },
      startAnimate () {
        this.map.resize();
        this.sliderVal = 0
        if (this.animateInt) clearInterval(this.animateInt)
        this.animateInt = setInterval(() => {
          const {sliderVal} = this
          this.sliderVal = sliderVal + .01
          this.filterByTime(this.sliderVal)
        }, 100)
      }
    },

    filters: {
      shortTime (timestamp) {
        const parts = (new Date(timestamp)).toGMTString().split(' ')
        return `${parts[1]} ${parts[2]}`
      },
      shortestTime (timestamp) {
        const parts = (new Date(timestamp)).toGMTString().split(' ')
        return `${parts[2]} ${parts[3]}`
      }
    }
  }
</script>

<style src="./styles/map.css"></style>